import Home from './Home.data-manager-af-app-name.vue'

export default {Home}
